/**
 * This Consumer is used to hold consumer attributes.
*/
export class Consumer {
  public name: string;
  public id: string;
  public businessUnit: string;
  public type: string;
  public clientVersion: string;
  public requestDateTime: string;
  public hostName: string;
  public businessTransactionType: string;
  public contextId: string;
  public secondContextId: string;
  public thirdContextId: string;

  constructor(name: string, id: string, businessUnit: string, type: string, clientVersion: string, requestDateTime: string,
    hostName: string, businessTransactionType: string, contextId: string, secondContextId: string, thirdContextId: string) {
    this.name = name;
    this.id = id;
    this.businessUnit = businessUnit;
    this.type = type;
    this.clientVersion = clientVersion;
    this.requestDateTime = requestDateTime;
    this.hostName = hostName;
    this.businessTransactionType = businessTransactionType;
    this.contextId = contextId;
    this.secondContextId = secondContextId;
    this.thirdContextId = thirdContextId;
  }
}
